// Test IDs for the Autonomous CMO Engine landing page.

export const HOME = {
  navLogo: 'home-nav-logo',
  navTryDemo: 'home-nav-try-demo',
  heroTitle: 'home-hero-title',
  heroSubtitle: 'home-hero-subtitle',
  heroCtaDemo: 'home-hero-cta-demo',
  heroCtaMetrics: 'home-hero-cta-metrics',
  metricCard: (key) => `home-metric-card-${key}`,
  featureCard: (i) => `home-feature-card-${i}`,
  sampleScriptSection: 'home-sample-script-section',
  manifestoChapter: (i) => `home-manifesto-chapter-${i}`,
  marquee: 'home-marquee',
  demoAppName: 'demo-input-app-name',
  demoPlatform: 'demo-select-platform',
  demoCoreFunction: 'demo-input-core-function',
  demoTargetAudience: 'demo-input-target-audience',
  demoPrimaryGoal: 'demo-select-primary-goal',
  demoSubmitBtn: 'demo-submit-btn',
  demoLoading: 'demo-loading-state',
  demoError: 'demo-error-message',
  demoResult: 'demo-result-panel',
  leadEmailInput: 'lead-email-input',
  leadAppNameInput: 'lead-app-name-input',
  leadSubmitBtn: 'lead-submit-btn',
  leadSuccessMsg: 'lead-success-message',
  footer: 'home-footer',
  navLoginBtn: 'home-nav-login-btn',
  navUserMenu: 'home-nav-user-menu',
  navDashboardLink: 'home-nav-dashboard-link',
  navAdminLink: 'home-nav-admin-link',
  navLogoutBtn: 'home-nav-logout-btn',
  navSessionsBtn: 'home-nav-sessions-btn',
  demoGenerateSequencesBtn: 'demo-generate-sequences-btn',
  demoSequenceResult: 'demo-sequence-result',
};

export const AUTH = {
  loginEmailInput: 'auth-login-email-input',
  loginPasswordInput: 'auth-login-password-input',
  loginSubmitBtn: 'auth-login-submit-btn',
  registerNameInput: 'auth-register-name-input',
  registerEmailInput: 'auth-register-email-input',
  registerPasswordInput: 'auth-register-password-input',
  registerSubmitBtn: 'auth-register-submit-btn',
  googleLoginBtn: 'auth-google-login-btn',
  authTabLogin: 'auth-tab-login',
  authTabRegister: 'auth-tab-register',
  authError: 'auth-error-message',
  forgotPasswordLink: 'auth-forgot-password-link',
  forgotPasswordEmailInput: 'auth-forgot-password-email-input',
  forgotPasswordSubmitBtn: 'auth-forgot-password-submit-btn',
  forgotPasswordSuccessMessage: 'auth-forgot-password-success-message',
  forgotPasswordBackBtn: 'auth-forgot-password-back-btn',
  resetPasswordNewInput: 'auth-reset-password-new-input',
  resetPasswordConfirmInput: 'auth-reset-password-confirm-input',
  resetPasswordSubmitBtn: 'auth-reset-password-submit-btn',
  resetPasswordSuccessMessage: 'auth-reset-password-success-message',
  resetPasswordError: 'auth-reset-password-error-message',
  resetPasswordLoginLink: 'auth-reset-password-login-link',
};

export const DASHBOARD = {
  addAppBtn: 'dashboard-add-app-btn',
  portfolioTypeFilter: 'dashboard-portfolio-type-filter',
  appCard: (id) => `dashboard-app-card-${id}`,
  appCardGenerateBtn: (id) => `dashboard-app-generate-btn-${id}`,
  appCardDeleteBtn: (id) => `dashboard-app-delete-btn-${id}`,
  appCardOpenBtn: (id) => `dashboard-app-open-btn-${id}`,
  appCardConnectedBadge: (id) => `dashboard-app-connected-badge-${id}`,
  appCardPlatformPill: (id, platform) => `dashboard-app-platform-pill-${id}-${platform}`,
  generateToneDialog: 'dashboard-generate-tone-dialog',
  generateToneOption: (tone) => `dashboard-generate-tone-option-${tone}`,
  generateToneCustomInput: 'dashboard-generate-tone-custom-input',
  generateToneConfirmBtn: 'dashboard-generate-tone-confirm-btn',
  generateFocusFeatureSelect: 'dashboard-generate-focus-feature-select',
  generateFeatureRecommendationBanner: 'dashboard-generate-feature-recommendation-banner',
  renderCaptionStyleSelect: (id) => `render-caption-style-select-${id}`,
  addAppFeaturesInput: 'dashboard-add-app-features',
  appFeaturesInput: 'dashboard-app-features',
  addAppSocialPlatformOption: (p) => `dashboard-add-app-social-platform-option-${p}`,
  addAppNameInput: 'dashboard-add-app-name-input',
  addAppPlatform: 'dashboard-add-app-platform',
  addAppCoreFunction: 'dashboard-add-app-core-function',
  addAppAudience: 'dashboard-add-app-audience',
  addAppGoal: 'dashboard-add-app-goal',
  addAppSubmitBtn: 'dashboard-add-app-submit-btn',
  addAppProductType: 'dashboard-add-app-product-type',
  addAppWebsiteUrl: 'dashboard-add-app-website-url',
  addAppSocialHandle: 'dashboard-add-app-social-handle',
  detailGenerateBtn: 'dashboard-detail-generate-btn',
  detailApplyHookBtn: 'dashboard-detail-apply-hook-btn',
  detailApplyHookSelect: 'dashboard-detail-apply-hook-select',
  detailApplyHookConfirm: 'dashboard-detail-apply-hook-confirm',
  markWinningBtn: (id) => `dashboard-mark-winning-btn-${id}`,
  priorityBadge: (id) => `dashboard-priority-badge-${id}`,
  campaignHistoryItem: (id) => `dashboard-campaign-history-item-${id}`,
  emptyState: 'dashboard-empty-state',
  detailGenerateSequencesBtn: 'dashboard-detail-generate-sequences-btn',
  sequenceHistoryItem: (id) => `dashboard-sequence-history-item-${id}`,
  renderVideoBtn: (id) => `render-video-btn-${id}`,
  renderVideoProgress: (id) => `render-video-progress-${id}`,
  renderVideoPreviewBtn: (id) => `render-video-preview-btn-${id}`,
  renderAiVideoModeSelect: (id) => `render-ai-video-mode-select-${id}`,
  renderCostEstimate: (id) => `render-cost-estimate-${id}`,
  renderVideoDownloadBtn: (id) => `render-video-download-btn-${id}`,
  renderVideoError: (id) => `render-video-error-${id}`,
  renderVideoRetryBtn: (id) => `render-video-retry-btn-${id}`,
  renderVoiceSelect: (id) => `render-voice-select-${id}`,
  renderVoicePreviewBtn: (id) => `render-voice-preview-btn-${id}`,
  addAppVoiceSelect: 'dashboard-add-app-voice-select',
  addAppVoicePreviewBtn: 'dashboard-add-app-voice-preview-btn',
  appDefaultVoiceSelect: 'dashboard-app-default-voice-select',
  appDefaultVoiceSaveBtn: 'dashboard-app-default-voice-save-btn',
  renderedVideosTab: 'dashboard-rendered-videos-tab',
  renderGallery: 'dashboard-render-gallery',
  renderCostDashboard: 'dashboard-render-cost-dashboard',
  renderCostBadge: (id) => `dashboard-render-cost-badge-${id}`,
  renderAiBadge: (id) => `dashboard-render-ai-badge-${id}`,
  monthlyUsagePill: 'dashboard-monthly-usage-pill',
  uploadClipSlotInput: (slot) => `dashboard-upload-clip-slot-input-${slot}`,
  uploadClipSlotRemoveBtn: (slot) => `dashboard-upload-clip-slot-remove-btn-${slot}`,
  uploadFullVideoInput: 'dashboard-upload-full-video-input',
  uploadFullVideoRemoveBtn: 'dashboard-upload-full-video-remove-btn',
  renderGalleryEmpty: 'dashboard-render-gallery-empty',
  renderGalleryItem: (id) => `dashboard-render-gallery-item-${id}`,
  renderGalleryPlayBtn: (id) => `dashboard-render-gallery-play-btn-${id}`,
  renderGalleryAdLinks: (id) => `dashboard-render-gallery-ad-links-${id}`,
  renderGalleryDownloadBtn: (id) => `dashboard-render-gallery-download-btn-${id}`,
  renderGalleryDeleteBtn: (id) => `dashboard-render-gallery-delete-btn-${id}`,
  renderVideoChangeVoiceBtn: (id) => `render-video-change-voice-btn-${id}`,
  renderVideoRerenderBtn: (id) => `render-video-rerender-btn-${id}`,
  growthLeadTab: 'dashboard-growth-lead-tab',
  growthLeadAppLink: (id) => `dashboard-growth-lead-app-link-${id}`,
  growthLeadMessage: (i) => `growth-lead-message-${i}`,
  growthLeadInput: 'growth-lead-input',
  growthLeadSendBtn: 'growth-lead-send-btn',
  growthLeadLoading: 'growth-lead-loading',
  growthLeadError: 'growth-lead-error',
  growthLeadResetBtn: 'growth-lead-reset-btn',
  growthLeadResetCancelBtn: 'growth-lead-reset-cancel-btn',
  growthLeadResetConfirmBtn: 'growth-lead-reset-confirm-btn',
  growthLeadExportBtn: (i) => `growth-lead-export-btn-${i}`,
  budgetTrackerTab: 'dashboard-budget-tracker-tab',
  budgetTargetCpaInput: 'dashboard-budget-target-cpa-input',
  budgetTargetRoasInput: 'dashboard-budget-target-roas-input',
  budgetSaveTargetsBtn: 'dashboard-budget-save-targets-btn',
  budgetCampaignSelect: 'dashboard-budget-campaign-select',
  budgetDateInput: 'dashboard-budget-date-input',
  budgetSpendInput: 'dashboard-budget-spend-input',
  budgetClicksInput: 'dashboard-budget-clicks-input',
  budgetConversionsInput: 'dashboard-budget-conversions-input',
  budgetRevenueInput: 'dashboard-budget-revenue-input',
  budgetLogEntryBtn: 'dashboard-budget-log-entry-btn',
  budgetEmptyState: 'dashboard-budget-empty-state',
  budgetEntriesTable: 'dashboard-budget-entries-table',
  budgetEntryRow: (id) => `dashboard-budget-entry-row-${id}`,
  budgetDeleteEntryBtn: (id) => `dashboard-budget-delete-entry-btn-${id}`,
  budgetNoCpaHint: 'dashboard-budget-no-cpa-hint',
  budgetDiscussGrowthLeadBtn: (id) => `dashboard-budget-discuss-growth-lead-btn-${id}`,
  budgetSpendCapInput: 'dashboard-budget-spend-cap-input',
  budgetEntrySourceBadge: (id) => `dashboard-budget-entry-source-badge-${id}`,
  impressionsBadge: (id) => `dashboard-budget-entry-impressions-${id}`,
  viewsBadge: (id) => `dashboard-budget-entry-views-${id}`,
  engagementsBadge: (id) => `dashboard-budget-entry-engagements-${id}`,
  ctrStatCard: 'dashboard-budget-ctr-stat-card',
  viewRateStatCard: 'dashboard-budget-view-rate-stat-card',
  engagementRateStatCard: 'dashboard-budget-engagement-rate-stat-card',
  campaignFilterSelect: 'dashboard-budget-campaign-filter-select',
  budgetNoPerformanceHint: 'dashboard-budget-no-performance-hint',
  publishTab: 'dashboard-publish-tab',
  metaConnectBtn: 'dashboard-meta-connect-btn',
  metaDisconnectBtn: 'dashboard-meta-disconnect-btn',
  googleAdsConnectBtn: 'dashboard-google-ads-connect-btn',
  googleAdsDisconnectBtn: 'dashboard-google-ads-disconnect-btn',
  publishToMetaBtn: (id) => `dashboard-publish-to-meta-btn-${id}`,
  publishToGoogleBtn: (id) => `dashboard-publish-to-google-btn-${id}`,
  adCampaignResumeBtn: (id) => `dashboard-ad-campaign-resume-btn-${id}`,
  adCampaignPauseBtn: (id) => `dashboard-ad-campaign-pause-btn-${id}`,
  adCampaignApproveBtn: (id) => `dashboard-ad-campaign-approve-btn-${id}`,
  adSpendRollup: 'dashboard-ad-spend-rollup',
  downloadClientReportBtn: 'dashboard-download-client-report-btn',
  regenerationHistoryPanel: 'dashboard-regeneration-history-panel',
  regenerationHistoryEmpty: 'dashboard-regeneration-history-empty',
  regenerationHistoryItem: (id) => `dashboard-regeneration-history-item-${id}`,
  pendingApprovalsBanner: 'dashboard-pending-approvals-banner',
  pendingApprovalItem: (id) => `dashboard-pending-approval-item-${id}`,
  leaderboardPublishBtn: (id) => `dashboard-leaderboard-publish-btn-${id}`,
  adCampaignCreativeNote: (id) => `dashboard-ad-campaign-creative-note-${id}`,
  memoryPinToggleBtn: 'growth-lead-memory-pin-toggle-btn',
  memoryPinPanel: 'growth-lead-memory-pin-panel',
  memoryPinInput: 'growth-lead-memory-pin-input',
  memoryPinAddBtn: 'growth-lead-memory-pin-add-btn',
  memoryPinEmpty: 'growth-lead-memory-pin-empty',
  memoryPinItem: (i) => `growth-lead-memory-pin-item-${i}`,
  memoryPinRemoveBtn: (i) => `growth-lead-memory-pin-remove-btn-${i}`,
  firstVisitGuide: 'dashboard-first-visit-guide',
  firstVisitGuideDismissBtn: 'dashboard-first-visit-guide-dismiss-btn',
  voiceLibrary: 'dashboard-voice-library',
  voiceLibraryItem: (id) => `dashboard-voice-library-item-${id}`,
  voiceLibraryRenameBtn: (id) => `dashboard-voice-library-rename-btn-${id}`,
  voiceLibraryDeleteBtn: (id) => `dashboard-voice-library-delete-btn-${id}`,
  voiceLibraryRenameInput: (id) => `dashboard-voice-library-rename-input-${id}`,
  voiceLibraryRenameSaveBtn: (id) => `dashboard-voice-library-rename-save-btn-${id}`,
  voiceLibraryRenameCancelBtn: (id) => `dashboard-voice-library-rename-cancel-btn-${id}`,
  renderGalleryThumbnail: (id) => `dashboard-render-gallery-thumbnail-${id}`,
  renderGalleryDeleteAllBtn: 'dashboard-render-gallery-delete-all-btn',
  renderGalleryPublishBtn: (id) => `dashboard-render-gallery-publish-btn-${id}`,
  publishSocialModal: 'dashboard-publish-social-modal',
  socialConnectPanel: 'dashboard-social-connect-panel',
  socialConnectRow: (key) => `dashboard-social-connect-row-${key}`,
  socialConnectBtn: (key) => `dashboard-social-connect-btn-${key}`,
  socialConnectDisconnectBtn: (key) => `dashboard-social-connect-disconnect-btn-${key}`,
  socialConnectInstagramCheckBtn: 'dashboard-social-connect-instagram-check-btn',
  socialConnectInstagramCheckResult: 'dashboard-social-connect-instagram-check-result',
  renderGalleryPublishStatusBadge: (id) => `dashboard-render-gallery-publish-status-badge-${id}`,
  publishPlatformToggle: (platform) => `dashboard-publish-platform-toggle-${platform}`,
  publishPageSelect: 'dashboard-publish-page-select',
  publishChannelSelect: 'dashboard-publish-channel-select',
  publishCaptionInput: 'dashboard-publish-caption-input',
  publishScheduleInput: 'dashboard-publish-schedule-input',
  publishSubmitBtn: 'dashboard-publish-submit-btn',
  publishHistoryItem: (id) => `dashboard-publish-history-item-${id}`,
  sessionActivityDialog: 'session-activity-dialog',
  sessionActivityItem: (id) => `session-activity-item-${id}`,
  sessionActivityLogoutBtn: (id) => `session-activity-logout-btn-${id}`,
  videoScriptEditBtn: (id) => `dashboard-video-script-edit-btn-${id}`,
  videoScriptHookInput: (id) => `dashboard-video-script-hook-input-${id}`,
  videoScriptCaptionInput: (id, i) => `dashboard-video-script-caption-input-${id}-${i}`,
  videoScriptSaveBtn: (id) => `dashboard-video-script-save-btn-${id}`,
  videoScriptCancelBtn: (id) => `dashboard-video-script-cancel-btn-${id}`,
  videoScriptHashtagsInput: (id) => `dashboard-video-script-hashtags-input-${id}`,
  videoScriptRegenerateHashtagsBtn: (id) => `dashboard-video-script-regenerate-hashtags-btn-${id}`,
  voiceSearchInput: 'dashboard-voice-search-input',
  addAppExtractBtn: 'dashboard-add-app-extract-btn',
  addAppSocialHandleInput: (platform) => `dashboard-add-app-social-handle-input-${platform}`,
  planBadge: 'dashboard-plan-badge',
  upgradePlanBtn: 'dashboard-upgrade-plan-btn',
  pricingDialog: 'dashboard-pricing-dialog',
  pricingPlanCard: (plan) => `dashboard-pricing-plan-card-${plan}`,
  pricingSubscribeBtn: (plan) => `dashboard-pricing-subscribe-btn-${plan}`,
  walletBalance: 'dashboard-wallet-balance',
  walletAddFundsBtn: 'dashboard-wallet-add-funds-btn',
  walletAmountInput: 'dashboard-wallet-amount-input',
  walletTopUpConfirmBtn: 'dashboard-wallet-topup-confirm-btn',
  planUsagePill: 'dashboard-plan-usage-pill',
  walletLedgerBtn: 'dashboard-wallet-ledger-btn',
  walletLedgerDialog: 'dashboard-wallet-ledger-dialog',
  walletLedgerItem: (i) => `dashboard-wallet-ledger-item-${i}`,
};

export const ADMIN = {
  totalUsers: 'admin-total-users',
  totalApps: 'admin-total-apps',
  totalCampaigns: 'admin-total-campaigns',
  totalLeads: 'admin-total-leads',
  chartCampaignsByDay: 'admin-chart-campaigns-by-day',
  chartPlatforms: 'admin-chart-platforms',
  chartGoals: 'admin-chart-goals',
  topAppsTable: 'admin-top-apps-table',
  leadsTable: 'admin-leads-table',
  gscPanel: 'admin-gsc-panel',
  gscConnectBtn: 'admin-gsc-connect-btn',
  gscRefreshBtn: 'admin-gsc-refresh-btn',
  gscTableRow: (i) => `admin-gsc-table-row-${i}`,
  gscNoData: 'admin-gsc-no-data',
  socialPreviewSection: 'admin-social-preview-section',
  socialPreviewSelect: 'admin-social-preview-select',
  socialPreviewTwitterCard: 'admin-social-preview-twitter-card',
  socialPreviewFacebookCard: 'admin-social-preview-facebook-card',
  linkCheckSection: 'admin-link-check-section',
  linkCheckRunBtn: 'admin-link-check-run-btn',
  linkCheckBrokenRow: (i) => `admin-link-check-broken-row-${i}`,
  linkCheckAllHealthy: 'admin-link-check-all-healthy',
  grantPlanSection: 'admin-grant-plan-section',
  grantPlanEmailInput: 'admin-grant-plan-email-input',
  grantPlanSelect: 'admin-grant-plan-select',
  grantPlanSubmitBtn: 'admin-grant-plan-submit-btn',
};

export const BLOG = {
  searchInput: 'blog-search-input',
  tagChipAll: 'blog-tag-chip-all',
  tagChip: (tag) => `blog-tag-chip-${tag.replace(/\s+/g, '-').toLowerCase()}`,
  trendingBadge: (tag) => `blog-trending-badge-${tag.replace(/\s+/g, '-').toLowerCase()}`,
  emptyState: 'blog-empty-state',
  newsletterSection: 'blog-newsletter-section',
  newsletterEmailInput: 'blog-newsletter-email-input',
  newsletterSubmitBtn: 'blog-newsletter-submit-btn',
  newsletterSuccessMsg: 'blog-newsletter-success-message',
  relatedPostsSection: 'blog-related-posts-section',
  relatedPostCard: (slug) => `blog-related-post-card-${slug}`,
  commentsSection: 'blog-comments-section',
  commentsEmpty: 'blog-comments-empty',
  commentItem: (id) => `blog-comment-item-${id}`,
  commentNameInput: 'blog-comment-name-input',
  commentEmailInput: 'blog-comment-email-input',
  commentTextInput: 'blog-comment-text-input',
  commentSubmitBtn: 'blog-comment-submit-btn',
  commentError: 'blog-comment-error-message',
  commentReplyBadge: (id) => `blog-comment-reply-badge-${id}`,
  commentReplyBtn: (id) => `blog-comment-reply-btn-${id}`,
  commentReplyInput: (id) => `blog-comment-reply-input-${id}`,
  commentReplySubmitBtn: (id) => `blog-comment-reply-submit-btn-${id}`,
  commentDeleteBtn: (id) => `blog-comment-delete-btn-${id}`,
};
